import React from "react";
import ExamPageLayout from "./ExamPageLayout";
import {useTranslation} from "react-i18next";

const Toefl = () => {
    const {t} = useTranslation()
    return (<ExamPageLayout
        title={t("toeflExamLabel")}
        subtitle={t("toeflExamLabelFull")}
        description={t("toeflExamDescription")}
        structure={t("toeflExamStructure")}
    />)
}

export default Toefl
